import styled from 'styled-components';

export const MobileRespawnBannerStyled = styled.div`
    border-radius: 16px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: relative;
    
    .mobile-bonus-banner {
        background: linear-gradient(270.98deg, #A9E345 1.23%, #FFDAB9 100%);
        > div {
            background-position: right 10px;
            background-size: 140px;
            background-repeat: no-repeat;
            background-image: url(${process.env.PUBLIC_URL + '/assets/bonus/bonus-respawn-dollar.png'});
        }
    }
    .btn-primary {
        &, &:hover, &:active, &:focus {
            border: none;
            background: var(--color-neutral-10);
        }
        svg {
            fill: var(--text-color-dark);
        }
    }
`;
